import { Component, EventEmitter, inject, Input, NgZone, Output } from '@angular/core';
import { Article, City, SubCategory } from '../../../../interfaces/article';

import { InViewportDirective } from '../../../../directives/in-viewport.directive';
import { Connect } from '../../../../classes/connect';
import { ArticleArtisticGeneral } from '../../../../interfaces/article-artistic';
import { PdfThumbnailService } from '../../../../services/pdf-thumbnail.service';

@Component({
    selector: 'app-card-archive',
    imports: [
    InViewportDirective
],
    templateUrl: './card-archive.component.html',
    styleUrl: './card-archive.component.scss'
})
export class CardArchiveComponent {

  private readonly zone = inject(NgZone);
  private readonly pendingThumbs = new Set<string>();

  thumbnailsA: { [key: string]: string } = {}; // Memorizza le thumbnail dei PDF Artistico
  thumbnailsH: { [key: string]: string } = {}; // Memorizza le thumbnail dei PDF Storico

  urlServerLaraApiMultimedia = Connect.urlServerLaraApiMultimedia;

  @Input() articlesH: Article[] = [];
  @Input() articlesA: ArticleArtisticGeneral[] = [];
  @Input() type: number = 0;

  @Output() navigate = new EventEmitter<number>()

  constructor(private pdfThumbnailService: PdfThumbnailService) { }

  ensureArtisticThumbnail(article: ArticleArtisticGeneral): void {
    const src = article.src;
    if (article.ext !== 'pdf' || !src || this.thumbnailsA[src] || this.pendingThumbs.has(src)) {
      return;
    }
    this.pendingThumbs.add(src);
    void this.pdfThumbnailService.generateThumbnail(this.urlServerLaraApiMultimedia + src)
      .then(thumbnail => {
        this.zone.run(() => {
          this.thumbnailsA = { ...this.thumbnailsA, [src]: thumbnail };
        });
      })
      .catch(() => {
        this.pendingThumbs.delete(src);
      });
  }

  ensureHistoricalThumbnail(article: Article): void {
    const src = article.src;
    if (article.ext !== 'pdf' || !src || this.thumbnailsH[src] || this.pendingThumbs.has(src)) {
      return;
    }
    this.pendingThumbs.add(src);
    void this.pdfThumbnailService.generateThumbnail(this.urlServerLaraApiMultimedia + src)
      .then(thumbnail => {
        this.zone.run(() => {
          this.thumbnailsH = { ...this.thumbnailsH, [src]: thumbnail };
        });
      })
      .catch(() => {
        this.pendingThumbs.delete(src);
      });
  }

  cardClick(id: number) {
    this.navigate.emit(id);
  }

  cityLabel(city: City | string | null): string {
    if (!city) {
      return '';
    }
    return typeof city === 'string' ? city : city.name;
  }

  subcategoryLabel(subcategory: SubCategory | string | null): string {
    if (!subcategory) {
      return '';
    }
    return typeof subcategory === 'string' ? subcategory : subcategory.title;
  }

  dateLabel(article: Article): string {
    if (article.date_type == 1 && article.date_article) {
      return String(article.date_article);
    }
    if (article.date_type == 2 && article.year_article) {
      return article.year_article;
    }
    if (article.date_type == 3 && (article.yearfrom_article || article.yearto_article)) {
      return `${article.yearfrom_article ?? ''} - ${article.yearto_article ?? ''}`.replace(/^\s-\s|\s-\s$/g, '').trim();
    }
    return '';
  }

}
